import React from "react";
import CommonListSection from "../../component/common/CommonListSection";

const products = [
  {
    icon: "/images/plantIcon1.png",
    title: "Fermented Organic Manure (FOM)",
    desc: "Fermented organic manure enriches soil with beneficial microbes, improving nutrient availability and soil health. It enhances root growth, boosts crop yield, and supports sustainable, chemical-free farming.",
  },
  {
    icon: "/images/plantIcon1.png",
    title: "Liquid Fermented Organic Manure (LFOM)",
    desc: "Liquid Fermented Organic Manure provides fast-absorbing nutrients and beneficial microbes, improving soil fertility and crop growth.",
  },
  {
    icon: "/images/plantIcon1.png",
    title: "Phosphate Rich Organic Manure (PROM)",
    desc: "PROM (Phosphate Rich Organic Manure) improves phosphorus availability in soil, strengthening root development and increasing crop yield.",
  },
  {
    icon: "/images/plantIcon1.png",
    title: "Bio-Fertilizers and Other Organic Liquids (Drip & Foliar)",
    desc: "Bio-fertilizers and other organic liquids (drip & foliar) supply beneficial microbes and nutrients directly to plants, enhancing growth, immunity, and yield naturally.",
  },
];
const myMedia = [
  "/images/product/1.webp", // YouTube Link
  "/images/product/2.webp",
  "/images/product/3.webp",
  "/images/product/4.webp",
  "/images/product/5.webp",
  "/images/product/6.webp",
  "/images/product/7.webp",
  "/images/product/8.webp",
  "/images/product/9.webp",
  "/images/product/10.webp",
  "/images/product/11.webp",
  "/images/product/12.webp",
  "/images/product/13.webp",
  "/images/product/14.webp",
  "/images/product/15.webp",
];
const ProductRangeSection = () => {
  return (
    <CommonListSection
      subtitle="Our Range"
      title="Our Range of Organic Fertilizers"
      description="We offer a diverse range of organic fertilizers tailored to meet the needs of various crops and soil types:"
      items={products}
      media={myMedia}
      autoPlayInterval={4000} // Optional: change speed
      imageAlt="Carbon Footprint"
    />
  );
};

export default ProductRangeSection;
